import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.getSettings()
      .then((s) => { if (mounted) setSettings(s); })
      .catch(() => {
        // fallback defaults
        if (mounted) setSettings({
          company_name: "RS Construction",
          full_name: "RS Construction (HI) LTD",
          tagline: "Build Without Limits.",
          phone: "020 7544 1449",
          phone_alt: "020 8991 2848",
          mobile: "07711 310 892",
          email: "info@rsconstructionhi.co.uk",
          address_line1: "65th Floor, Studio 501",
          address_line2: "International House",
          address_line3: "223 Regent Street",
          address_city: "London W1B 2QD",
          hours_weekdays: "Mon – Fri: 08:00 – 18:00",
          hours_saturday: "Saturday: 09:00 – 16:00",
          hours_sunday: "Sunday: Closed",
          instagram: "https://instagram.com",
          facebook: "https://facebook.com",
          google: "https://google.com",
        });
      });
    return () => { mounted = false; };
  }, []);

  return (
    <SettingsCtx.Provider value={settings}>
      {children}
    </SettingsCtx.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsCtx);
}
